<template>
  
    <div class="">

    
        <div class="myCenter" v-if="!isFromPitchPage">  

            <h2 class=" text-red-700 myClassTitle w-2/3 font-extrabold">
            {{mySlot.two_pitch.name}}
            </h2>

        </div>

        <div class="w-full flex flex-col lg:flex-row items-center justify-center h-full pb-3 text-sm lg:text-lg text-grey-dark pt-2 ">

            <div class="myCenter flex w-full mt-2">

                <div class="flex flex-row justify-around pb-1 lg:pb-3 text-grey-dark">
                    
                    <div v-if="!isFromPitchPage && mySlot.pay_cash" class="myOverlayText myFullCenter">
                        
                        <span class="font-bold">{{$t('pitch.cash/hr')}} </span>

                        <h2 class="text-pink-700">{{mySlot.cash_hour_price}}</h2>
                    </div>

                    <div  v-if="!isFromPitchPage && mySlot.pay_points" class="myOverlayText myFullCenter">
                        
                        <span class="font-bold">{{$t('pitch.points/hr')}} </span>

                        <h2 class="text-pink-700">{{mySlot.hour_price}}</h2>
                    </div>

                    <div v-if="isFromPitchPage && mySlot.pay_cash" class="myOverlayText myFullCenter">
                        
                        <span class="font-bold">{{$t('pitch.cash/hr')}} </span>

                        <h2 class="text-pink-700">{{mySlot.cash_hour_price}}</h2>
                    </div>

                    <div  v-if="isFromPitchPage && mySlot.pay_points" class="myOverlayText myFullCenter">
                        
                        <span class="font-bold">{{$t('pitch.points/hr')}} </span>

                        <h2 class="text-pink-700">{{mySlot.hour_price}}</h2>
                    </div>

                    <div class="myOverlayText myFullCenter" v-if="!isFromPitchPage">
                        
                        <span class="font-bold">{{$t('pitch.minNumber')}} </span>

                        <h2 class="text-pink-700">{{mySlot.two_pitch.min_number}}x{{mySlot.two_pitch.min_number}}</h2>
                    </div>

                    <!-- <div class="myOverlayText myFullCenter" v-if="!isFromPitchPage">
                        
                        <span class="font-bold">{{$t('pitch.maxNumber')}} </span>

                        <h2 class="text-pink-700">{{mySlot.two_pitch.min_number}}x{{mySlot.two_pitch.min_number}}</h2>
                    </div> -->

                    <div class="myOverlayText myFullCenter" v-if="!isFromPitchPage">
                        <h3 class="text-black text-sm font-extrabold font-sans" >
                        <p class="text-pink-800">{{$t('classes.type')}}</p>
                        <p class="text-sm lg:text-lg border-pink-800 border-2 lg:border-4 rounded-full"></p>{{type}}</h3>
                    </div>
                </div>
            </div>    
        </div>
    </div>        
</template>


<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';

import myUpdates from '../../hasura/myUpdates';

import componentsHelpers from '../../classes/componentHelpers';

// import pitchTimeSlot from './PitchTimeSlot';


export default {

    created(){


    },

    mounted(){
        
        const dayDate = this.dayDate;

        if(this.isFromPitchPage){

            // console.log(`myPitch: ${JSON.stringify(this.myPitch)}`)
            this.type = this.myPitch.type.name;

        }else{

            this.type = this.mySlot.two_pitch.type.name;
        }

        // console.log(`mounted startTime: ${this.searchStartTime}`)
            
        // console.log(`mounted endTime: ${this.searchEndTime}`)

    },

    props: {

        isFromPitchPage: false,
        
        disablePage: false,

        disableButton: false,

        isOnline: false,

        dayDate: '',

        searchStartTime: '',

        searchEndTime: '',

        mySlot:{

            type: Object
        },

        myPitch:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        instructors:{

            type: Array 
        },

        myReload: {

            type: Function
        },

        index: 0,

        changeCardView: {

            type: Function
        },


        displayModal: {

            type: Function
        },
    },

    components:{

        RingLoader,
        // pitchTimeSlot
    },

    methods:{

    },

  data: function(){

    return{

        loading:false,
        startTime: moment(new Date(`1970/01/01 ${this.mySlot.start_time}`)).format('hh:mm A'),
        endTime: moment(new Date(`1970/01/01 ${this.mySlot.end_time}`)).format('hh:mm A'),
        bookingId: 0,
        type: '',   

        points: 0,
        capacity: 0,

        days: [7],
        isBgGreen: false,

        paymentByPoints: this.mySlot.pay_points,

    }
  },

}
</script>

<style>

</style>
